import { DocumentStatusEnum } from "@models/documents/document-status.enum";

export const documentStatusLabels: Record<DocumentStatusEnum, string> = {
  [DocumentStatusEnum.Draft]: 'Draft',
  [DocumentStatusEnum.LodgementPending]: 'Lodgement Pending',
  [DocumentStatusEnum.AuthorisationPending]: 'Authorisation Pending',
  [DocumentStatusEnum.SignaturePending]: 'Signature Pending',
  [DocumentStatusEnum.Completed]: 'Completed',
};
